import { Injectable } from '@angular/core';
import { CaiApi } from '../../../core/utils/cai-api';
import { API_WALLET } from '../../constant/api-wallet.const';
import {
  ConvertAmountRequest,
  WalletConvertedPayLaterBalance,
} from '../../../core/model/wallet.model';
import { RecaptchaService } from '../../../core';

@Injectable({
  providedIn: 'root',
})
export class WalletCurrencyService {
  constructor(private readonly recaptchaService: RecaptchaService) {}

  async convertAmount(
    from: string,
    to: string,
    amount: number,
    sale = false,
    isGuestUser?: boolean,
  ): Promise<WalletConvertedPayLaterBalance> {
    const init = {
      queryParams: {
        from,
        to,
        sale,
        amount: amount?.toString()?.replace(/,/g, ''),
      },
    } as any;
    if (isGuestUser) {
      init.headers = {
        'x-captcha-token': await this.recaptchaService.getCaptchaToken(),
      };
    }
    return CaiApi.get(API_WALLET.name, API_WALLET.URLs.Currency.Convert, init);
  }

  async batchConvertAmount(
    request: ConvertAmountRequest[],
    isGuestUser?: boolean,
  ): Promise<WalletConvertedPayLaterBalance[]> {
    const headers = {};
    if (isGuestUser) {
      headers['x-captcha-token'] =
        await this.recaptchaService.getCaptchaToken();
    }
    return CaiApi.post(API_WALLET.name, API_WALLET.URLs.Currency.Convert, {
      body: request,
      headers,
    });
  }
}
